export default __webpack_public_path__ + "static/media/anniversary8.9d3e3fcf.webp";